export const environment = {
  production: true,
  apiHost: "https://gamefaceapi.groupworkguru.com",
  wsHost: "wss://b-40602efe-cbe6-4a56-b705-f2bc5c1315c6-1.mq.us-west-2.amazonaws.com:61619",
  uiHost: "https://gameface.groupworkguru.com",
  awsMqttHost: 'wss://a1ljm7251ppn2y-ats.iot.us-west-2.amazonaws.com/mqtt',
  awsRegion: 'us-west-2'
};
